import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ICustomerRole } from "../models/auth/CustomerRole";
import { DefaultResponseWithData } from "../models/system";

export default function useCustomerRoles() {
  const { get } = useApiHelper();

  // Roles are managed in the core dashboard; the widget only assigns them
  const roles = useQuery({
    queryKey: ["customerRoles"],
    queryFn: () => get<DefaultResponseWithData<ICustomerRole[]>>("/customer/roles"),
    staleTime: 1000 * 60 * 5,
  });

  return {
    roles,
  };
}
